type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const OutdoorIcon = ({ size = 18, color = 'currentColor', className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 3v18" />
    <path d="M12 7c-3 0-6-2-6-2s3-2 6-2 6 2 6 2-3 2-6 2z" />
    <path d="M12 13c-3 0-6-2-6-2s3-2 6-2 6 2 6 2-3 2-6 2z" />
    <line x1="6" y1="21" x2="18" y2="21" />
  </svg>
);
